import CApiHelper from '@frontrow/console/src/entities/helpers/common-api-helper'
import {ajaxJsonCall, ajaxCall} from '@freckle/ajax'
import {type operations} from '@frontrow/console/src/open-api/fancy-api/generated-client'
import {type FancyBody, type fancyOperations} from '@frontrow/console/src/open-api/clients'

// Datatable
import {type FetchDataParamsT} from '@frontrow/console/src/components/common/data-table'
import {createDatatableUrl} from '@frontrow/console/src/helpers/data-table'
import {type BasicDistrictT} from '@frontrow/console/src/models/district'

export function fetchDistricts(
  fetchDataParams?: FetchDataParamsT | null
): Promise<operations['getDistrictsR']['responses'][200]['content']['application/json']> {
  const baseUrl = CApiHelper.fancyPaths.v2.districts._()
  const url = createDatatableUrl(baseUrl, fetchDataParams)
  return ajaxJsonCall({url, method: 'GET'})
}

export function updateDistrictById(
  districtId: number,
  updatedDistrict: BasicDistrictT,
  clearClassLinkOneRosterToken: boolean
): Promise<operations['patchDistrictR']['responses'][200]['content']['application/json']> {
  if (clearClassLinkOneRosterToken) {
    throw new Error('Clear ClassLink One Roster token not implemented')
  }
  // Built key by key: `patchDistrictR` accepts fewer keys than a district has,
  // and names the ClassLink/Clever ids differently.
  const districtReq: FancyBody<fancyOperations['patchDistrictR']> = {
    name: updatedDistrict.name,
    city: updatedDistrict.city,
    administrativeArea: updatedDistrict.administrativeArea,
    postalCode: updatedDistrict.postalCode,
    formattedAddressLines: updatedDistrict.formattedAddressLines,
    countryCode: updatedDistrict.countryCode,
    isFake: updatedDistrict.isFake,

    // The backend requires these fields to be named slightly differently
    classLinkId: updatedDistrict.classLinkDistrictId,
    cleverId: updatedDistrict.cleverDistrictId,

    classLinkOneRosterToken: updatedDistrict.classLinkOneRosterToken
  }
  return ajaxJsonCall({
    url: CApiHelper.fancyPaths.v2.districts.district._(districtId),
    method: 'PATCH',
    data: JSON.stringify(districtReq)
  })
}

export function postDistrict(
  districtData: BasicDistrictT
): Promise<operations['postDistrictsR']['responses'][200]['content']['application/json']> {
  const districtReq = {
    ...districtData,
    classLinkId: districtData.classLinkDistrictId,
    cleverId: districtData.cleverDistrictId
  }

  return ajaxJsonCall({
    url: CApiHelper.fancyPaths.v2.districts._(),
    method: 'POST',
    data: JSON.stringify(districtReq)
  })
}

export function deleteIdentityProviderAssociations(districtId: number): Promise<string> {
  return ajaxCall({
    url: CApiHelper.fancyPaths.v2.districts.district.district_identity_providers.associations(
      districtId
    ),
    method: 'DELETE',
    contentType: 'application/json; charset=utf-8',
    dataType: 'text',
    timeout: 0
  })
}

export function deleteDistrict(districtId: number): Promise<string> {
  return ajaxCall({
    url: CApiHelper.fancyPaths.v2.districts.district._(districtId),
    method: 'DELETE',
    contentType: 'application/json; charset=utf-8',
    dataType: 'text'
  })
}

export function fetchDistrictsRgpCsvs(
  districtId: number
): Promise<operations['getRostersR']['responses'][200]['content']['application/json']> {
  return ajaxJsonCall({
    url: CApiHelper.fancyPaths.v2.districts.district.rosters._(districtId),
    method: 'GET'
  })
}
